import React from 'react';
import { StoreApi } from 'zustand';
import { ULPath } from '@ul/common';

export type WalletNavigationStore = {
    isForgetPinFlow?: boolean;
    previousPath: ULPath;
};

export type WalletNavigationStoreFunction = {
    setIsForgetPinFlow: (isForgetPinFlow: boolean) => void;
    setPreviousPath: (path?: ULPath) => void;
};

export type WalletNavigationContextProps = {
    walletNavigationStore: StoreApi<WalletNavigationStore & WalletNavigationStoreFunction>;
};

const WalletNavigationContext = React.createContext<WalletNavigationContextProps | null>(null);
WalletNavigationContext.displayName = 'WalletNavigationContext';
export { WalletNavigationContext };
